import React from "react";
var __jsx = React.createElement;
import { nanoid } from '@reduxjs/toolkit';
import get from 'lodash/get';
import { Controller, useFormContext } from 'react-hook-form';

var AutoGeneratedIdField = function AutoGeneratedIdField(_ref) {
  var name = _ref.name;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  var defaultValue = get(control._defaultValues, name);
  return __jsx(Controller, {
    control: control,
    name: name,
    defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : nanoid(),
    render: function render() {
      return __jsx(React.Fragment, null);
    }
  });
};

export default AutoGeneratedIdField;